import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Card } from "react-bootstrap";
import api from "../../axiosConfig";
import BxumForm from "./BxumForm";

const BxumEdit = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [submitting, setSubmitting] = useState(false);
  const [initialValues, setInitialValues] = useState({ cod: "", descriere: "", zecimale: 0, um_saft: "" });

  useEffect(() => {
    api.get(`/bxums/${id}`).then((res) => {
      setInitialValues(res.data);
    }).catch((err) => {
      alert("Eroare la încărcare: " + (err.response?.data?.detail || err.message));
    });
  }, [id]);

  const onSubmit = async (form) => {
    try {
      setSubmitting(true);
      await api.put(`/bxums/${id}`, form);
      navigate("/bxums");
    } catch (err) {
      alert("Eroare la actualizare: " + (err.response?.data?.detail || err.message));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Card className="mt-4 p-3">
      <h3>Editează unitate de măsură — #{id}</h3>
      <button type="button" className="btn btn-outline-secondary mb-3" onClick={() => navigate("/bxums")}>Înapoi la listă</button>
      <BxumForm initialValues={initialValues} onSubmit={onSubmit} submitting={submitting} />
    </Card>
  );
};

export default BxumEdit;
